import { initialChild } from "../../../../share/types/case/children";
import { initialAbductor } from "../../../../share/types/case/abductor";
import shortid from 'shortid'
import _ from 'lodash';

export class PersonHelper {
    constructor(public getState, public setValue) {
        
    }
    public addPerson = (type: string) => {
        const state = { ...this.getState() };
        if (type === 'child') {
            state.caseInfo.children.push(_.cloneDeep({ ...initialChild, childId: shortid.generate() }));
        } else {
            state.caseInfo.abductors.push(_.cloneDeep({ ...initialAbductor, abductorId: shortid.generate() }));
        }
        this.setValue(state);
    }

    public removePerson = (personId: string, type: string) => {
        const state = { ...this.getState() };
        if (type === 'child' && state.caseInfo.children.length > 1) {
            state.caseInfo.children = state.caseInfo.children.filter(child => child.childId !== personId);
        } else {
            state.caseInfo.abductors = state.caseInfo.abductors.filter(abductor => abductor.abductorId !== personId);
        }
        this.setValue(state);
    }
}